import { createElement, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { FeaturebaseProvider } from "featurebase-js/react";
import { CURRENT_USER_FEATUREBASE_WIDGET_TOKEN } from "api";
import config from "config";
import { useStores } from "contexts";

export const FeaturebaseScript = () => {
  const { userStore } = useStores();
  const [fetchAuthToken] = useLazyQuery(CURRENT_USER_FEATUREBASE_WIDGET_TOKEN);
  const [featurebaseJwt, setFeaturebaseJwt] = useState<string>();

  const currentUser = userStore.platformStore?.currentUser;
  const email = currentUser?.emailAddress;
  const userId = String(currentUser?.id || userStore.userId || "");

  useEffect(() => {
    let isCurrent = true;
    setFeaturebaseJwt(undefined);

    if (!email) return;

    fetchAuthToken().then(({ data }) => {
      if (isCurrent) {
        setFeaturebaseJwt(data?.currentUserFeaturebaseWidgetToken || undefined);
      }
    });

    return () => {
      isCurrent = false;
    };
  }, [email, fetchAuthToken]);

  if (!config.featurebaseAppId || !featurebaseJwt) return null;
  console.log({
    featurebaseAppId: config.featurebaseAppId,
    email,
    featurebaseJwt,
    featurebaseLanguage: config.featurebaseLanguage,
    userId,
  });

  return createElement(FeaturebaseProvider, {
    appId: config.featurebaseAppId,
    email,
    featurebaseJwt,
    language: config.featurebaseLanguage,
    theme: config.featurebaseTheme as "dark" | "light",
    userId: email ? userId : undefined,
  });
};
